import React from 'react';
import { Glyphicon } from 'react-bootstrap';
import { getElementsDimensions } from './utils';

const zoomToFit = (getKeysWhere, flowId, mapElementIdFlowId, groupElementIdFlowId, mapElements, groupElements, graphElement, setViewBox, setZoom) => {
    const mapElementIds = getKeysWhere((_, val) => val === flowId, mapElementIdFlowId);
    const groupElementIds = getKeysWhere((_, val) => val === flowId, groupElementIdFlowId);
    const allElementIds = [...mapElementIds, ...groupElementIds];

    const { lowestX, lowestY, highestX, highestY } = getElementsDimensions(allElementIds, mapElements, groupElements);

    const width = highestX - lowestX;
    const height = highestY - lowestY;

    const { height: availableHeight, width: availableWidth } = graphElement.current.getBoundingClientRect();

    const neededXZoom = width / availableWidth;
    const neededYZoom = height / availableHeight;

    const zoomAmount = neededXZoom > neededYZoom ? neededXZoom : neededYZoom;

    const newWidth = availableWidth * zoomAmount;
    const newHeight = availableHeight * zoomAmount;

    setViewBox({
        x: lowestX,
        y: lowestY,
        width: newWidth,
        height: newHeight,
    });

    setZoom(zoomAmount);
};

const GraphActionMenu = ({
    getKeysWhere,
    flowId,
    mapElementIdFlowId,
    groupElementIdFlowId,
    mapElements,
    groupElements,
    graphElement,
    zoom,
    setZoom,
    setViewBox,
}) => (
    <div className="btn-group btn-group-vertical graph-actions-menu">
        <button onClick={() => {}} className="btn btn-default graph-action" title="Search"><Glyphicon glyph="search" /></button>
        <button
            onClick={() => zoom(0.9)}
            className="btn btn-default graph-action"
            title="Zoom in"
        >
            <Glyphicon glyph="zoom-in" />
        </button>
        <button
            onClick={() => zoom(1.1)}
            className="btn btn-default graph-action"
            title="Zoom out"
        >
            <Glyphicon glyph="zoom-out" />
        </button>
        <button
            onClick={() => zoomToFit(
                getKeysWhere,
                flowId,
                mapElementIdFlowId,
                groupElementIdFlowId,
                mapElements,
                groupElements,
                graphElement,
                setViewBox,
                setZoom,
            )}
            className="btn btn-default graph-action"
            title="Zoom to fit Graph"
        >
            <Glyphicon glyph="screenshot" />
        </button>
        <button onClick={() => {}} className="btn btn-default graph-action" title="Help"><Glyphicon glyph="info-sign" /></button>
    </div>
);

export default GraphActionMenu;
